// extracted by mini-css-extract-plugin
module.exports = {"toggle-switch":"ToggleSwitch_toggle-switch__1GQHI","switch":"ToggleSwitch_switch__3j5xE"};